// src/components/shared/analytics/NotFoundAnalytics.tsx

"use client"

import { useEffect, useRef } from "react"

import { sendEvent, stripSensitiveParams } from "~/lib/gtag"

/**
 * Fires a `page_not_found` event on mount, distinct from the plain `page_view`
 * the URL also produces, so 404s (broken internal links, decayed inbound URLs)
 * are reportable. Captures the path + referrer. Render once inside any
 * `not-found.tsx`. Fire-once-per-mount guarded.
 */
export default function NotFoundAnalytics(): null {
  const sent = useRef(false)
  useEffect(() => {
    if (sent.current) return
    sent.current = true
    sendEvent({
      action: "page_not_found",
      params: {
        page_path: window.location.pathname,
        // A same-origin referrer can carry a secret query (e.g. a tokenized
        // /checkout/success); strip sensitive params before sending it to GA4.
        ...(document.referrer ? { referrer: stripSensitiveParams(document.referrer) } : {}),
      },
    })
  }, [])
  return null
}
